import React from "react";

export default function JotformIntegration() {
  return (
    <div className="bg-slate-50 p-6 md:p-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Contact Form</h1>
          <p className="text-slate-600">Fill out the form below to get in touch</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <iframe
            id="JotFormIFrame"
            title="Contact Form"
            onLoad={() => window.parent.scrollTo(0,0)}
            allowFullScreen
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/YOUR_FORM_ID"
            frameBorder="0"
            style={{
              minWidth: '100%',
              maxWidth: '100%',
              height: '539px',
              border: 'none'
            }}
            scrolling="no"
          />
        </div>
      </div>
    </div>
  );
}